// Promotion + campaign code handling (submitPromo / submitCampaign and
// the reset helpers).
//
// Extracted verbatim from DealerForm.vue; merged back via `mixins`.
import { validatePromo } from "@/services/api/promo";
import { getCampaign } from "@/services/api/utility";
import { log as devLog } from "@/utils/logger";

export default {
  methods: {
    async submitPromo(promotion) {
      this.$bvToast.toast(
        `We're searching for the promotion code ${promotion}`,
        {
          title: "Searching for promotions",
          variant: "info",
          autoHideDelay: 5000,
        }
      );

      validatePromo(this.promoRequestPayload(promotion))
        .then(
          (response) => {
            if (response.data != null) {
              {
                devLog(
                  "checking if direct billing is true",
                  response.data["associated_w_direct_billing__c"]
                );
                if (
                  response.data["associated_w_direct_billing__c"] == "true" ||
                  response.data["associated_w_direct_billing__c"] == true
                ) {
                  this.promotion_state_value = false;
                  this.$bvToast.toast(
                    "Promotion codes with direct billing are not valid for this app.",
                    {
                      title: "Invalid promotion code.",
                      variant: "danger",
                      autoHideDelay: 5000,
                    }
                  );
                  this.updateCartPrice();
                  return;
                }

                this.$bvToast.toast(
                  `We've found ${promotion}. The type is: ${response.data["promotion_type__c"]}`,
                  {
                    title: "Promotion found!",
                    variant: "success",
                    autoHideDelay: 5000,
                  }
                );

                console.log(response.data);
                this.promotion_valid_on_business_type__c =
                  response.data["valid_on_business_type__c"];
                this.promotion_valid_on_membership__c =
                  response.data["valid_on_membership__c"];
                this.promotion_state_value = true;
                this.promotion_sfid = response.data["sfid"];
                this.promotion_valid = true;
                this.promotion_value_in_days =
                  response.data["value_time_in_days__c"];
                this.promotion_price =
                  response.data["value_discount_in_dollars__c"];
                this.promotion_value_in_dollars =
                  response.data["value_discount_in_dollars__c"];
                this.promotion_value_percentage_discount =
                  response.data["value_discount_in_percentage__c"];
                this.promotion_type__c = response.data["promotion_type__c"];
                this.promotion_desc2 = response.data["description__c"];
                this.related_product_details =
                  response.data["related_product_details"];
                this.promotion_desc = response.data["promotion_details__c"];
                this.promotion_title = response.data["title__c"];
                this.promotion_ongoing_promotion_type =
                  response.data["ongoing_promo_type__c"];

                // Validate promo code is applicable to the selected membership type
                if (!this.validatePromoMembershipType()) {
                  this.resetPromotionDetails();
                  this.promotion_code = promotion;
                  return;
                }

                console.log(
                  "Related product details: " + this.related_product_details
                );
                // console.log if they match
                if (
                  this.related_product_details !== null &&
                  this.related_product_details !== undefined
                ) {
                  console.log(
                    this.related_product_details.name === "Trailer Care"
                  );
                  if (this.related_product_details.name === "Trailer Care") {
                    this.updateCartPrice();
                  }
                }

                console.log(
                  "this.promotion_ongoing_promotion_type: " +
                    this.promotion_ongoing_promotion_type
                );
                if (
                  this.promotion_ongoing_promotion_type == "Ongoing with ARB" ||
                  this.promotion_ongoing_promotion_type == "One Time with ARB"
                ) {
                  console.log(
                    this.promotion_ongoing_promotion_type ==
                      "Ongoing with ARB" ||
                      this.promotion_ongoing_promotion_type ==
                        "One Time with ARB"
                  );

                  console.log("Setting autorenew_status to true");
                  this.show_display_auto_renew;
                  this.checkbox_display;
                  this.autorenew_status = true;
                  this.promotion_arb_required = true;
                  this.arb_value = true;
                }
                this.updateCartPrice();
              }
            }
          },
          (error) => {
            this.handlePromoApiError(error, promotion);
          }
        );
    },
    async submitCampaign(campaign) {
      this.$bvToast.toast(`We're searching for the campaign code ${campaign}`, {
        title: "Searching for campaigns",
        variant: "info",
        autoHideDelay: 5000,
      });

      getCampaign({
        campaign_name: campaign,
      })
        .then(
          (response) => {
            console.log(response);
            if (response.data != null) {
              if ("Error" in response.data) {
                if (
                  response.data["Error"].localeCompare(
                    "No campaign found with the ID."
                  ) == 0
                ) {
                  this.campaign_state_value = false;
                  this.$bvToast.toast(`${campaign} was not found.`, {
                    variant: "danger",
                    title: "Campaign not found",
                    autoHideDelay: 5000,
                  });
                } else if (
                  response.data["Error"].localeCompare(
                    "No campaign found with the ID."
                  ) != 0
                ) {
                  console.log(response);
                  this.$bvToast.toast(
                    "This promotion code is either no longer active, or not applicable to the current membership.",
                    {
                      title: "Invalid promotion code.",
                      variant: "danger",
                      autoHideDelay: 5000,
                    }
                  );
                }
              } else {
                this.$bvToast.toast(`We've found '${campaign}'.`, {
                  variant: "success",
                  title: "Campaign found!",
                  autoHideDelay: 5000,
                });
                this.campaign_state_value = true;
                this.campaign_desc = response.data["name"];
                this.campaign_good_on =
                  response.data["good_on_invoice_type__c"];
                this.campaign_sfid = response.data["sfid"];
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
    resetCampaignDetails() {
      (this.campaign_good_on = null),
        (this.campaign_desc = null),
        (this.campaign = "");
      this.campaign_state_value = null;
      this.updateCartPrice();

      this.$bvToast.toast("Campaign cleared from the form.", {
        variant: "info",
        title: "Campaign cleared",
        autoHideDelay: 5000,
      });
    },
    resetActivationDetails() {
      Object.keys(this.activation_codes).forEach((key) => {
        this.activation_codes[key] = null;
      });
      this.updateCartPrice();
    },
    resetPromotionDetails() {
      this.promotion_title = null;
      this.promotion_value_percentage_discount = null;
      this.promotion_sfid = null;
      this.promotion_valid_on_business_type__c = null;
      this.promotion_valid_on_membership__c = null;
      this.promotion_state_value = null;
      this.promotion_valid = false;
      this.promotion_price = 0;
      this.promotion_type__c = null;
      this.title__c = null;
      this.promotion_value_in_dollars = null;
      this.promotion_value_in_days = null;
      this.promotion_code = null;
      this.promotion_details__c = null;
      this.promotion_desc = null;
      this.promotion_ongoing_promotion_type = null;
      this.promotion_arb_required = false;
      this.do_not_clear_promo = "false";
      this.autorenew_status = false;
      this.arb_value = false;
      this.updateCartPrice();

      this.$bvToast.toast("Promotion code cleared from the form.", {
        variant: "info",
        title: "Promotion cleared",
        autoHideDelay: 5000,
      });
    },
  },
};
